<template>
  <div>
    <!-- Invoice Info -->
    <v-col
      cols="12"
      class="py-0"
    >
      <h3>{{ $t('label.review_order') }}:</h3>
    </v-col>
    <v-col
      class="pt-2 mt-0 pb-0 mx-auto"
      cols="12"
      md="10"
    >
      <div class="mx-16 receipt mt-4 mb-8">
        <div class="receipt-list py-2 px-4 black--text">
          <!-- invoice line items -->
          <template v-for="(item,i) in invoiceInfo.items">
            <div
              :key="`item_${i}`"
              class="my-4"
            >
              <span class="font-weight-medium text-body-2">{{ item.description }}
                <span class="float-right">{{ item.amount }}</span>
              </span>
              <template v-for="(discount,di) in item.discountInfos">
                <div
                  :key="`item_${i}_discount_${di}`"
                >
                  <span class="text-body-2">{{ discount.shortDescription }}
                    <span class="float-right">{{ discount.discountAmount }}</span>
                  </span>
                </div>
              </template>
            </div>
          </template>

          <div
            v-if="discountInfo"
            class="my-2"
          >
            <span class="font-weight-medium text-body-1">{{ discountInfo.shortDescription }}
              <span class="float-right">{{ discountInfo.discountAmount }}</span>
            </span>
          </div>
          <v-divider light />
          <p
            v-if="invoiceInfo.tax"
            class="my-2"
          >
            {{ $t('label.vat') }}: <span class="float-right">{{ invoiceInfo.tax }}</span>
          </p>
          <p class="my-2">
            {{ $t('label.total') }}: <span class="float-right">{{ invoiceInfo.total }}</span>
          </p>
          <!-- <p class="pt-2 py-0 my-0">
          Created: <span class="font-weight-medium">{{ invoiceInfo.created }}</span>
        </p> -->
          <!-- applied balance -->
          <p
            v-if="invoiceInfo.appliedBalance"
            class="my-2"
          >
            {{ $t('label.applied_balance') }} <span class="float-right">{{ invoiceInfo.appliedBalance }}</span>
          </p>
          <v-divider light />
          <p
            v-if="invoiceInfo.futureProrationDate"
            class="font-weight-bold my-3"
          >
            {{ $t('label.amount_due_on', [invoiceInfo.futureProrationDate] ) }} <span class="float-right">{{ invoiceInfo.amountDue }}</span>
          </p>
          <p
            v-else
            class="font-weight-bold my-3"
          >
            {{ $t('label.amount_due') }} <span class="float-right">{{ invoiceInfo.amountDue }}</span>
          </p>
          <template v-if="subscriptionPriceInfo && subscriptionPriceInfo.intervalPeriodically">
            <v-divider light />
            <div class="text-caption text-center my-0 pt-4 pb-2">
              {{ $t('label.subscription_renewed_periodically', [subscriptionPriceInfo.intervalPeriodically]) }}
              <template v-if="subscriptionPriceInfo?.discountInfo?.validUntilOrDurationDescription">
                {{ subscriptionPriceInfo.discountInfo.validUntilOrDurationDescription }}
              </template>
            </div>
          </template>
        </div>
      </div>
    </v-col>
  </div>
</template>

<script setup lang="ts">
import { PropType, computed, onMounted } from 'vue';
import { DiscountInfo, InvoiceInfo, PriceInfo } from '@/services/billing-utils';
import { ProductType } from '@/api/api-billing';

const props = defineProps({
  invoiceInfo: { type: Object as PropType<InvoiceInfo>, required: true },
});

const discountInfo = computed(() => {
  const di = props.invoiceInfo?.discountInfo;
  if (!di || props.invoiceInfo.items.find(
    (ii) => ii.discountInfos.find(
      (iidi) => iidi.discount?.name === di.discount?.name,
    ),
  )) return undefined;
  return di;
});

const subscriptionPriceInfo = computed(() => {
  const items = props.invoiceInfo.items.toReversed();

  const index = items.findIndex(
    (i) => i.amountNumber > 0
    && i.priceInfo?.price?.product?.type === ProductType.Subscription
    && i.priceInfo.intervalPeriodically,
  );

  if (index < 0) return undefined;

  const priceInfo = { ...items[index].priceInfo };
  priceInfo.discountInfo = items[index].discountInfos.reduce(
    (odi, di) => ((di.discount?.discountAmount ?? 0) > (odi?.discount?.discountAmount ?? 0) ? di : odi),
    undefined as DiscountInfo | undefined,
  );

  console.log('subscriptionPriceInfo: ', priceInfo);
  return priceInfo;
});

onMounted(() => {
  console.log('invoice details mounted:', props.invoiceInfo, discountInfo.value, subscriptionPriceInfo.value);
});

</script>

<style lang="scss">

.receipt {
  border-radius: 6px 6px 0 0;
  background-color: #fff;
  position: relative;
  box-shadow: 0 0 8px 2px rgba(0,0,0,0.1);
  filter: drop-shadow(0 2px 1px rgba(#000, 0.3));
  margin: 0 auto;
}

.receipt:after {
  background-image:
  linear-gradient(135deg, #fff 0.5rem, transparent 0),
  linear-gradient(-135deg, #fff 0.5rem, transparent 0);
    background-position: left-bottom;
    background-repeat: repeat-x;
    background-size: 1rem;
    content: '';
    display: block;
    position: absolute;
    bottom: -1rem;
    left: 0;
    width: 100%;
    height: 1rem;
}

</style>
